<template>
  <el-dialog
    :title="
      user.orgs.length ? 'Выбор текущей организации' : 'Добавление организации'
    "
    :visible="true"
    :width="widthDialog"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :show-close="false"
    class="check-organization-modal"
  >
    <el-table
      v-if="user.loading"
      v-loading="user.loading"
      style="width: 100%"
    />
    <template v-if="!user.loading">
      <template v-if="user.orgs.length">
        <el-radio-group v-model="radio" class="choose-org">
          <el-radio v-for="(org, i) in user.orgs" :key="org.id" :label="i">
            {{ org.organization.short_name }}
          </el-radio>
        </el-radio-group>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="chooseCurrent">
            Сохранить
          </el-button>
        </span>
      </template>
      <AddOrganization
        v-else
        :user-id="user.id"
        @addedOrganization="$emit('addedOrganization')"
      />
    </template>
  </el-dialog>
</template>

<script>
import { SET_CURRENT } from '@/store/actions/userprofile'
import { mapGetters } from 'vuex'
import AddOrganization from './AddOrganization'

export default {
  name: 'CheckOrganization',
  components: {
    AddOrganization,
  },
  data() {
    return {
      radio: 0,
    }
  },
  computed: {
    ...mapGetters({
      user: 'userProfile/getIdOrgs',
    }),
  },
  methods: {
    chooseCurrent() {
      this.$store.commit(`userProfile/${SET_CURRENT}`, this.radio)
    },
  },
}
</script>

<style lang="sass">
.check-organization-modal
  .el-dialog
    margin-top: 3vh !important
  .el-dialog__body
    padding: 0 20px 40px 20px!important
  .el-radio-group.choose-org
    display: flex
    flex-direction: column
    margin-top: 15px
    label
      margin: 10px
      .el-radio__label
        font-size: 16px
        white-space: normal
</style>
